// Meta Pixel tracking helpers
// Fires the standard "Subscribe" event for CTA button clicks.
export const trackSubscribe = () => {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
        window.fbq("track", "Subscribe");
    }
};
